import React from "react";
import { useAppSelector, useAppDispatch } from "../../../../app/hooks";
import { resetShowViewReportModal } from "../../dvirSlice";
import { dvirReportStatusToText } from "../../../../models";
import "./ViewReportModal.scss";

const formatDate = (dateString: string): string => {
  if (!dateString) return "-";
  const hasTime = dateString.includes("T");
  const date = new Date(hasTime ? dateString : dateString + "T00:00:00");
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

const formatDateTime = (dateString: string): string => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return date.toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

export function ViewReportModal() {
  const dispatch = useAppDispatch();
  const report = useAppSelector((state) => state.dvir.showViewReportModal);

  const handleClose = () => {
    dispatch(resetShowViewReportModal());
  };

  if (!report) return null;

  const getStatusClass = (status: string) => {
    switch (status) {
      case "completed":
        return "status-completed";
      case "created":
        return "status-pending";
      default:
        return "status-pending";
    }
  };

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="view-report-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>DVIR Report Details</h3>
          <button className="close-button" onClick={handleClose}>
            ×
          </button>
        </div>

        <div className="modal-body">
          <div className="report-info-section">
            <div className="info-row">
              <span className="label">Date:</span>
              <span className="value">{formatDate(report.date)}</span>
            </div>
            <div className="info-row">
              <span className="label">Driver:</span>
              <span className="value">{report.driverName}</span>
            </div>
            <div className="info-row">
              <span className="label">Vehicle:</span>
              <span className="value">{report.vehicleLabel}</span>
            </div>
            <div className="info-row">
              <span className="label">Template:</span>
              <span className="value">{report.templateName}</span>
            </div>
            <div className="info-row">
              <span className="label">Status:</span>
              <span className={`status-badge ${getStatusClass(report.status)}`}>
                {dvirReportStatusToText[report.status]}
              </span>
            </div>
            {report.submittedAt && (
              <div className="info-row">
                <span className="label">Submitted:</span>
                <span className="value">{formatDateTime(report.submittedAt)}</span>
              </div>
            )}
          </div>

          <div className="answers-section">
            <h4>Questions & Answers</h4>
            {report.questionAnswers && report.questionAnswers.length > 0 ? (
              <div className="answers-list">
                {report.questionAnswers.map((qa, index) => (
                  <div key={qa.questionId || index} className="answer-item">
                    <div className="question">
                      <span className="question-number">{index + 1}.</span>
                      <span className="question-text">{qa.question}</span>
                      {qa.isRequired && <span className="required-badge">Required</span>}
                    </div>
                    <div className="answer">
                      {qa.answer || <span className="no-answer">No answer provided</span>}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="no-answers">
                <p>No answers have been submitted yet.</p>
              </div>
            )}
          </div>
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
